import type {
  FilterConditionDto,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdCondition
} from '@bindoc-projects/condition-domain-lib';

import type {
  FilterConditionPluginSpecification,
  FilterDetailedText,
} from '@bindoc-projects/filter-condition-domain-lib';
import {
  FilterConditionPluginImpl
} from '@bindoc-projects/filter-condition-domain-lib';

export const OP_HAS_DATA_CONDITION_ID = 'intuitiveOpHasData';
export const FilterConditionOpHasDataPluginType: FilterConditionPluginSpecification<
  boolean,
  FilterConditionOpHasDataDto,
  BdOpHasDataCondition
> = {
  type: 'intuitiveOpHasData',
  category: 'case',
  displayName: { de: 'Hat OP-Daten' },
  sortingIndex: 8,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionOpHasDataDto,
  ): FilterConditionPluginImpl<boolean> {
    return new FilterConditionOpHasDataPlugin(obj.flag);
  },
  fromCondition(
    jsonObj: BdOpHasDataCondition,
  ): FilterConditionPluginImpl<boolean> {
    return new FilterConditionOpHasDataPlugin(jsonObj.flag);
  },
  newInstance(): FilterConditionPluginImpl<boolean> {
    return new FilterConditionOpHasDataPlugin(true);
  },
};

export class FilterConditionOpHasDataPlugin extends FilterConditionPluginImpl<
  boolean,
  FilterConditionOpHasDataDto
> {
  static override Specification: FilterConditionPluginSpecification<
    boolean,
    FilterConditionOpHasDataDto,
    BdOpHasDataCondition
  > = FilterConditionOpHasDataPluginType;

  constructor(private _flag: boolean) {
    super(FilterConditionOpHasDataPluginType.type);
  }

  toCondition(): BdCondition {
    return new BdOpHasDataCondition(this._flag);
  }

  toJSON(): FilterConditionOpHasDataDto | null {
    return {
      type: this.type,
      flag: this._flag,
    };
  }

  toText(): string | null {
    return 'Hat OP-Daten';
  }

  override toDetailedText(): FilterDetailedText | null {
    const title = this.toText();
    if (!title) return null;
    if (this._flag === null || this._flag === undefined) return { title, items: [] };
    return { title, items: [this._flag ? 'Ja' : 'Nein'] };
  }

  toValue(): boolean {
    return this._flag;
  }

  override equals(other: FilterConditionOpHasDataPlugin): boolean {
    return super.equals(other) && this._flag === other._flag;
  }

  override valid(): boolean {
    return this._flag !== null && this._flag !== undefined;
  }

  override validationToText(): string {
    if (this.valid()) {
      return '';
    } else {
      return 'Ja/Nein auswählen';
    }
  }

  clone(): FilterConditionOpHasDataPlugin {
    return new FilterConditionOpHasDataPlugin(this._flag);
  }
}

export class BdOpHasDataCondition extends BdCondition {
  constructor(public flag: boolean) {
    super(OP_HAS_DATA_CONDITION_ID);
  }

  toJSON(): FilterConditionDto {
    return {
      [this.id]: {
        flag: this.flag,
      },
    };
  }
}

interface FilterConditionOpHasDataDto {
  type: string;
  flag: boolean;
}
